import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SimposiosService {
  constructor(private http: HttpClient) { }

  getSimposios() {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Simposio/All");
  }


  getSimposiosbyyear(year :string) {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Simposio/ByYear?year="+year);
  }
}